import React from "react";
import Section from "./Section";
import { blogs } from "../data/BlogDetails";

const sourceOf = (link) =>
  link.includes("medium.com") ? "Medium" : "Hashnode";

// Date-ordered list (newest first — order comes from BlogDetails.js).
const Writing = () => (
  <Section
    id="writing"
    title="Blogs"
    subtitle="Long-form posts on Web3, AI, ZK, and blockchain scalability."
  >
    <ol className="space-y-4">
      {blogs.map((blog) => (  
        <li key={blog.id}>
          <a
            href={blog.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group grid gap-1 rounded-2xl border border-line bg-surface p-5 transition-colors duration-100 hover:border-fg sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
          >
            <p className="font-mono text-xs text-faint sm:pt-1">
              {blog.date} · {sourceOf(blog.link)}
            </p>
            <div>
              <h3 className="font-medium underline-offset-4 group-hover:underline">
                {blog.title}
              </h3>
              <p className="mt-1 max-w-prose text-sm text-muted">
                {blog.description}
              </p>
            </div>
          </a>
        </li>
      ))}
    </ol>
  </Section>
);

export default Writing;
